import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { FestivalShopKiosksQuery, FestivalShopProductsQuery, ProductCategory } from '@/gql/myomr'

type FestivalShopKiosk = NonNullable<FestivalShopKiosksQuery['festivalShopKiosks']['nodes'][number]>
type FestivalShopProduct = NonNullable<FestivalShopProductsQuery['festivalShopProducts']['nodes'][number]>

export const useFestivalShopStore = defineStore('festivalShop', () => {
  const availableKiosks = ref<FestivalShopKiosk[]>([])
  const currentKiosk = ref<FestivalShopKiosk | null>(null)
  const currentProductCategory = ref<ProductCategory | null>(null)
  const currentProduct = ref<FestivalShopProduct | null>(null)

  function setAvailableKiosks(kiosks?: FestivalShopKiosk[] | null) {
    availableKiosks.value = kiosks ?? []
  }

  function setCurrentKiosk(kiosk?: FestivalShopKiosk | null) {
    currentKiosk.value = kiosk ?? null
  }

  function setCurrentProductCategory(category?: ProductCategory | null) {
    currentProductCategory.value = category ?? null
  }

  function setCurrentProduct(product?: FestivalShopProduct | null) {
    currentProduct.value = product ?? null
  }

  function resetFestivalShopContext() {
    setAvailableKiosks([])
    setCurrentKiosk(null)
    setCurrentProductCategory(null)
    setCurrentProduct(null)
  }

  return {
    availableKiosks,
    currentKiosk,
    currentProduct,
    currentProductCategory,
    resetFestivalShopContext,
    setAvailableKiosks,
    setCurrentKiosk,
    setCurrentProduct,
    setCurrentProductCategory,
  }
})
